import { Row, Col, Input, Button } from 'reactstrap';
import PickerRange from '@components/input/PickerRange';

const Header = ({
  handlePerPage,
  rowsPerPage,
  handleFilter,
  searchTerm,
  picker,
  setPicker,
  handleDownload,
  handleFilterDates
}) => {
  return (
    <div className="invoice-list-table-header w-100 me-1 ms-50 mt-2 mb-75">
      <Row>
        <Col xl="4" className="d-flex align-items-center p-0">
          <div className="d-flex align-items-center w-100">
            <label htmlFor="rows-per-page">Ver</label>
            <Input
              className="mx-50"
              type="select"
              id="rows-per-page"
              value={rowsPerPage}
              onChange={handlePerPage}
              style={{ width: '5rem' }}
            >
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="50">50</option>
            </Input>
            <label htmlFor="rows-per-page">Filas</label>
          </div>
        </Col>
        <Col className="d-flex align-items-center justify-content-between">
          <PickerRange value={picker} onChange={setPicker} />
          <Button
            color="primary"
            type="button"
            onClick={() => handleFilterDates()}
            style={{
              marginLeft: 20
            }}
          >
            Filtrar
          </Button>
        </Col>
        <Col
          xl="4"
          className="d-flex align-items-sm-center justify-content-xl-end justify-content-start flex-xl-nowrap flex-wrap flex-sm-row flex-column pe-xl-1 p-0 mt-xl-0 mt-1"
        >
          <div className="d-flex align-items-center mb-sm-0 mb-1 me-1">
            <label className="mb-0" htmlFor="search-invoice">
              Buscar:
            </label>
            <Input
              id="search-invoice"
              className="ms-50 w-100"
              type="text"
              value={searchTerm}
              onChange={(e) => handleFilter(e.target.value)}
            />
          </div>

          <div className="d-flex align-items-center table-header-actions">
            <Button
              className="add-new-episode"
              color="primary"
              onClick={() => handleDownload()}
            >
              Descargar
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Header;
